export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const CLEAR_PROFILE_SUCCESS = 'CLEAR_PROFILE_SUCCESS';

export const UPDATE_PREFERENCES_SUCCESS = 'UPDATE_PREFERENCES_SUCCESS'
export const PREFERENCES_LOADING = 'PREFERENCES_LOADING'

export const UPDATE_PREFERRED_CAP_TABLE_COLUMNS_SUCCESS = 'UPDATE_PREFERRED_CAP_TABLE_COLUMNS_SUCCESS'